import { useEffect, useRef, useState } from 'react';
import { Stage } from './animations';
import { Scene1, Scene2, Scene3, Scene4 } from './scenes-1-4';
import { Scene5, Scene6, Scene7, Scene8 } from './scenes-5-8';
import './HeroAnimation.css';

const SCENES = [Scene1, Scene2, Scene3, Scene4, Scene5, Scene6, Scene7, Scene8];

const ADVANCE_MS = 5000;
const ADVANCE_MS_REDUCED = 8000;
const FROZEN_TIME = 4.5;

const HeroAnimation = () => {
  const [idx, setIdx] = useState(0);
  const [reducedMotion, setReducedMotion] = useState(false);
  const [visible, setVisible] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mq.matches);
    const onChange = (e) => setReducedMotion(e.matches);
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
      return () => mq.removeEventListener('change', onChange);
    }
    mq.addListener(onChange);
    return () => mq.removeListener(onChange);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') return;
    const el = containerRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.1 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return undefined;
    const interval = reducedMotion ? ADVANCE_MS_REDUCED : ADVANCE_MS;
    const id = window.setTimeout(
      () => setIdx((i) => (i + 1) % SCENES.length),
      interval,
    );
    return () => window.clearTimeout(id);
  }, [idx, visible, reducedMotion]);

  const SceneComp = SCENES[idx];

  return (
    <div
      ref={containerRef}
      className="tep-anim"
      role="img"
      aria-label="TeachESLPro teacher workflow walkthrough"
    >
      <div className="tep-anim-stage">
        <Stage
          key={idx}
          width={1280}
          height={720}
          duration={5}
          background="#ece6d4"
          loop
          playing={visible && !reducedMotion}
          frozenTime={reducedMotion ? FROZEN_TIME : null}
        >
          <SceneComp />
        </Stage>
      </div>
    </div>
  );
};

export default HeroAnimation;
